// extracted by mini-css-extract-plugin
module.exports =  {"header-rating":"_wbDWe4","headerRating":"_wbDWe4","header-rating-space-between":"_b6kEwC","headerRatingSpaceBetween":"_b6kEwC"};